'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconUpRightFromSquare, iconUpRightFromSquareTag } from '@ni/nimble-components/dist/esm/icons/up-right-from-square';
import { wrap } from '../../utilities/react-wrapper';

export type { IconUpRightFromSquare };
export { iconUpRightFromSquareTag };
export const NimbleIconUpRightFromSquare = wrap(IconUpRightFromSquare);